import type { FunctionComponent, ReactNode } from "react";
import { createContext, useCallback, useContext, useRef } from "react";

type Context = {
  acquireAdslotIndex: () => number;
  releaseAdslotIndex: () => void;
};
const InlineOutstreamAdSlotContext = createContext<Context | undefined>(undefined);

type Props = { children?: ReactNode };

export const InlineOutstreamAdSlotContextProvider: FunctionComponent<Props> = ({ children }) => {
  const slotCount = useRef(0);

  const acquireAdslotIndex = useCallback(() => {
    const current = ++slotCount.current;
    return current;
  }, [slotCount]);

  const releaseAdslotIndex = useCallback(() => {
    slotCount.current--;
  }, [slotCount]);

  return (
    <InlineOutstreamAdSlotContext.Provider value={{ acquireAdslotIndex, releaseAdslotIndex }}>
      {children}
    </InlineOutstreamAdSlotContext.Provider>
  );
};

export const useInlineOutstreamAdSlotContext = () => {
  const context = useContext(InlineOutstreamAdSlotContext);
  if (context === undefined) {
    throw new Error("InlineOutstreamAdSlotContextProvider need to be rendered in the ancestor.");
  }
  return context;
};
